/**
 * Created by shubham on 10/5/18.
 */

import { Component } from '@angular/core';
import { APPCONFIG } from '../../../config';
import { MdDialog } from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HttpService } from '../../../shared/services/http.service';
import { SessionHandler } from '../../../shared/services/session-handler.service';
import { DialogComponent } from '../../../dialog/dialog.component';
import {TranslateService} from 'ng2-translate';


@Component({
    selector: 'add-manager',
    template: require('./addManager.component.html')
})
export class AddManagerComponent {

    dialogRef;
    userDetails: any;
    isSystemAdmin:boolean = false;
    isBUManager:boolean = false;
    isRegionalAdmin:boolean = false;
    isServiceOwner:boolean = false;
    isTradePartner:boolean = false;
    isSubUser:boolean = false;
    admins = [];
    countries = [];
    applications = [];
    businessUnits = [];
    AddManagerForm: FormGroup;
    AddManagerFormDetails: any;
    selectedItems = [];
    manager_settings = {};
    application_settings = {};

    constructor(private sessionHandler:SessionHandler, public httpService : HttpService, public dialog: MdDialog, private formBuilder: FormBuilder, 
        private translate: TranslateService) {

        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));

        if(this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0){
            if(this.userDetails.roleCode.includes(APPCONFIG.systemAdmin)) {
                this.isSystemAdmin = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.BUManager)) {
                this.isBUManager = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.regionalAdmin)) {
                this.isRegionalAdmin = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.serviceOwner)) {
                this.isServiceOwner = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.tradePartner)) {
                this.isTradePartner = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.subuser)) {
                this.isSubUser = true;
            }
        } else {
            this.httpService.noUserError();
        }

        if(this.isSystemAdmin){
            this.getCountries();
            this.getBusinessUnit();
            this.getAdmins();
            this.getApplications();
        }
    }

    public getCountries(){
        this.httpService.getRequest('lookupDataOperationsApi/v1/country').subscribe(
            res => { this.saveCountries(res); },
            err => { this.httpService.onEnd(); }
        );
    }
    public saveCountries(res){
        if(res && res.items){
            this.countries = res.items;
        }
        this.httpService.onEnd();
    }

    public getBusinessUnit() {
        this.httpService.getRequest('lookupDataOperationsApi/v1/businessUnit').subscribe(
            res => { this.saveBusinessUnit(res); },
            err => { this.httpService.onEnd(); }
        );
    }
    saveBusinessUnit(res) {
        if(res && res.items){
            this.businessUnits = res.items;
        }
        this.httpService.onEnd();
    }

    public getAdmins(){
        this.httpService.getRequest('superUserOperationsApi/v1/getCountryAdminList').subscribe(
            res => { this.saveAdmins(res); },
            err => { this.httpService.onEnd(); }
        );
    }
    public saveAdmins(res){
        if(res && res.items){
            this.admins = res.items;
        }
        this.httpService.onEnd();
    }

    public getApplications() {
        this.httpService.getRequest('applicationOperationApi/v1/getApplicationDropDownList').subscribe(
            res => { this.saveApplications(res); },
            err => { this.httpService.onEnd(); }
        );

    }
    public saveApplications(res){
        if(res && res.items){
            this.applications = res.items;
        }
        this.httpService.onEnd();
    }

    buildForm() {
        this.AddManagerForm = this.formBuilder.group({
            countryId: this.formBuilder.control(null, [Validators.required]),
            businessUnitId: this.formBuilder.control(null, [Validators.required]),
            /*managerId: this.formBuilder.control(null, [Validators.required]),*/
            managerData: this.formBuilder.control(null, [Validators.required]),
            applicationData: this.formBuilder.control(null, [Validators.required]),
        });
        this.AddManagerForm.valueChanges.subscribe(data => {
            this.AddManagerFormDetails = this.AddManagerForm.getRawValue();

            this.AddManagerFormDetails['managerIds'] = [];
            for (let d in this.AddManagerFormDetails.managerData){
                this.AddManagerFormDetails['managerIds'].push(this.AddManagerFormDetails.managerData[d]['id']);
            }

            this.AddManagerFormDetails['applicationId'] = [];
            for (let d in this.AddManagerFormDetails.applicationData){
                this.AddManagerFormDetails['applicationId'].push(this.AddManagerFormDetails.applicationData[d]['id']);
            }

            this.AddManagerFormDetails.validate = this.AddManagerForm.valid;
        });
    }

    public addManager(){
        this.httpService.postRequest(this.AddManagerFormDetails,'superUserOperationsApi/v1/addCountryBusinessUnitManagerMapping').subscribe(
            res => { this.saveAddManagerResponse(res); },
            err => { this.httpService.onEnd(); }
        );
    }
    public saveAddManagerResponse(res){
        if(res){
            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = "mngr_assigned_notify";
            this.dialogRef.afterClosed().subscribe(result => {
                window.location.href = '#/app/manager-assignment/list';
            });
        } else if(res.errorStatus == 'Fail') {
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = 'save_failed';
            this.httpService.onEnd();
        }
    };
    
    ngOnInit() {
        this.buildForm();

        var app_settings = {singleSelection: false,text:"",labelKey: "name",selectAllText:"",unSelectAllText:"",classes:"myclass custom-class"};
        var mgr_settings = {singleSelection: false,text:"",labelKey: "name",selectAllText:"",unSelectAllText:"",classes:"myclass custom-class"};
        this.translate.get('Select Applications').subscribe((res: string) => {app_settings.text = res;
            if(app_settings.text&&app_settings.selectAllText&&app_settings.unSelectAllText) {this.application_settings=app_settings;}
        });
        this.translate.get('Assign Manager').subscribe((res: string) => {mgr_settings.text = res;
            if(mgr_settings.text&&mgr_settings.selectAllText&&mgr_settings.unSelectAllText) {this.manager_settings=mgr_settings;}
        });
        this.translate.get('select_all').subscribe((res: string) => {app_settings.selectAllText=res;mgr_settings.selectAllText=res;
            if(mgr_settings.text&&mgr_settings.selectAllText&&mgr_settings.unSelectAllText) {this.manager_settings=mgr_settings;}
            if(app_settings.text&&app_settings.selectAllText&&app_settings.unSelectAllText) {this.application_settings=app_settings;}
        });
        this.translate.get('unselect_all').subscribe((res: string) => {app_settings.unSelectAllText=res;mgr_settings.unSelectAllText=res;
            if(mgr_settings.text&&mgr_settings.selectAllText&&mgr_settings.unSelectAllText) {this.manager_settings=mgr_settings;}
            if(app_settings.text&&app_settings.selectAllText&&app_settings.unSelectAllText) {this.application_settings=app_settings;}
        });
    

    }
    
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/system-level-setting/managerAssignment/addManager/addManager.component.ts